var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'component',
    'component__badge_role',
    _vm.type ? ("component__badge_role--type-" + _vm.type) : ''
]},[_c('span',[_vm._v(_vm._s(_vm.roleOutput))])])}
var staticRenderFns = []

export { render, staticRenderFns }